import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	all: {
		id: 'dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.all',
		defaultMessage: 'All',
		description: 'A label to show all categories',
	},
	addAGadget: {
		id: 'dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.add-a-gadget',
		defaultMessage: 'Add a Gadget',
		description: 'Title to add gadgets panel',
	},
	searchGadgets: {
		id: 'dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.search-gadgets',
		defaultMessage: 'Search gadgets',
		description: 'Placeholder for the search gadgets textfield',
	},
	searchGadgetsResult: {
		id: 'dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.search-gadgets-result',
		defaultMessage: '{num} {num, plural, one {gadget} other {gadgets}} found',
		description: 'The number of gadgets matching the search text and category',
	},
	closeAddGadgetPanel: {
		id: 'dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.close-add-gadget-panel',
		defaultMessage: 'Close the add gadget panel',
		description: 'Label for icon button that closes the add gadget panel',
	},
});
